var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarningSign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6049_5279)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.74472 6.34513C3.11225 4.65181 4.59152 3.16839 6.27945 1.79796C7.30578 0.964676 8.5363 0.970154 9.5636 1.79796C11.2601 3.16503 12.7361 4.64428 14.1009 6.34513C14.8868 7.32436 14.8921 8.55136 14.1009 9.52967C12.7192 11.2385 11.2231 12.7336 9.51285 14.1146C8.55091 14.8914 7.32438 14.8862 6.36154 14.1146C4.63165 12.7283 3.13099 11.2278 1.74472 9.49796C0.972484 8.53436 0.967241 7.30783 1.74472 6.34513Z",
    stroke: "#e36f7e",
    strokeWidth: 1.14286,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.9292 5.07227V7.92941",
    stroke: "currentColor",
    strokeWidth: 1.14286,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.9292 10.5007V10.7864",
    stroke: "currentColor",
    strokeWidth: 1.14286,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6049_5279"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningSign);
export default __webpack_public_path__ + "static/media/warningSign.b4f23868.svg";
export { ForwardRef as ReactComponent };